import usePageTitle from "@/hooks/usePageTitle";
import { Navigate, useLocation } from "react-router-dom";

export default function ActivitiesIndexPage() {
  usePageTitle("/activities", "Activities");
  const location = useLocation();

  return <Navigate to={`${location.pathname}/events`} replace />;
}
